// services/WarehouseProductItemBatchNoService.ts
import axios from 'axios';
import { WarehouseProductItemBatchNo } from '../models/WarehouseProductItemBatchNo';

const API_URL = process.env.REACT_APP_SERVER_URL + "/warehouseproductitembatchno";

const WarehouseProductItemBatchNoService = {
    getAllBatches: async (): Promise<WarehouseProductItemBatchNo[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllBatchNo`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getBatchesByProductItemId: async (productItemId: number) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getBatchNoByProductId/${productItemId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getBatchesByWarehouseId: async (warehouseId: number) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getBatchNoByWarehouseId/${warehouseId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getBatchesByProductIdAndWarehouseId: async (productItemId: number, warehouseId: number) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/product/${productItemId}/warehouse/${warehouseId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getBatchById: async (id: number): Promise<WarehouseProductItemBatchNo> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getBatchNoById/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    createBatch: async (batchData: Omit<WarehouseProductItemBatchNo, 'id' | 'created_time' | 'updated_time'>) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.post(`${API_URL}/add`, {
            ...batchData,
            supplier_id: batchData.supplier_id || null // Ensure null is sent if not provided
        }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    createBatchByStockBalanceTransfer: async (batchData: Omit<WarehouseProductItemBatchNo, 'id' | 'created_time' | 'updated_time'>) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.post(`${API_URL}/addByStockBalanceTransfer`, {
            ...batchData,
            supplier_id: batchData.supplier_id || null // Ensure null is sent if not provided
        }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    updateBatch: async (id: number, batchData: Omit<WarehouseProductItemBatchNo, 'created_time' | 'updated_time'>) => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.put(`${API_URL}/update/${id}`, batchData, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    deleteBatch: async (id: number): Promise<void> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        await axios.delete(`${API_URL}/delete/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    }
};

export default WarehouseProductItemBatchNoService;
